import React from 'react';
import { Control, FieldErrors, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { PersonalDataFieldset, AddressFieldset } from '@/features/Collaborators/Edit/Form/Fieldsets';
import { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';
import { CollaboratorFormContext } from '@/features/Collaborators/Edit/Contexts/CollaboratorFormContext';
import { Collaborator } from '@/features/Collaborators/Models/collaborator';

interface BasicInfoTabProps {
    context: CollaboratorFormContext;
    collaboratorId: string;
    control: Control<CollaboratorFormData>;
    setValue: UseFormSetValue<CollaboratorFormData>;
    watch: UseFormWatch<CollaboratorFormData>;
    errors: FieldErrors<CollaboratorFormData>;
    isSubmitting?: boolean;
}

const BasicInfoTab: React.FC<BasicInfoTabProps> = ({
    context,
    collaboratorId,
    control,
    setValue,
    watch,
    errors,
    isSubmitting = false
}) => {
    return (
        <div className="space-y-6">
            <PersonalDataFieldset
                context={context}
                collaboratorId={collaboratorId}
                control={control}
                errors={errors}
                isSubmitting={isSubmitting}
            />

            <AddressFieldset
                context={context}
                collaboratorId={collaboratorId}
                control={control}
                setValue={setValue}
                watch={watch}
                errors={errors}
                isSubmitting={isSubmitting}
            />
        </div>
    );
};

export default BasicInfoTab;
